import { Component, Input } from '@angular/core';
import {
  CobrancaDTO,
  FormaPagamento,
  FormaPagamentoNormalizado,
  Invoice,
  Locale,
} from 'src/app/core/types';
import { Utils } from '../@shared/utils/utils';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss'],
})
export class PaymentComponent {
  @Input() locale: Locale = 'ptBR';
  @Input() invoice: Invoice = {} as Invoice;
  @Input() formaPagamento: FormaPagamento = {} as FormaPagamento;
  @Input() cobranca: CobrancaDTO | null = null;

  isStripeProvider() {
    return (
      this.formaPagamento.detalhes['provedor'].nome.toLocaleLowerCase() ===
      'stripe'
    );
  }

  isCieloProvider() {
    return (
      this.formaPagamento.detalhes['provedor'].nome.toLocaleLowerCase() ===
      'cielo'
    );
  }

  isPix() {
    return this.normalizeNomeFormaPagamento(this.formaPagamento.tipo) === 'pix';
  }

  isBoleto() {
    return (
      this.normalizeNomeFormaPagamento(this.formaPagamento.tipo) === 'boleto'
    );
  }

  isCartao() {
    return (
      this.normalizeNomeFormaPagamento(this.formaPagamento.tipo) === 'cartao' ||
      this.normalizeNomeFormaPagamento(this.formaPagamento.tipo) ===
        'cartao_debito'
    );
  }

  normalizeNomeFormaPagamento(nome: string) {
    return Utils.normalize(nome) as FormaPagamentoNormalizado;
  }
}
